import type { ReactNode } from 'react';

type Props = {
  items: [label: string, value: ReactNode][];
  title?: string;
};

/** Read-only "label … value" list (AdminLTE `list-group-unbordered`). */
export const InfoList = ({ items, title }: Props) => (
  <>
    {title && <h3 className="profile-username text-center">{title}</h3>}
    <ul className="list-group list-group-unbordered">
      {items.map(([label, value]) => (
        <li key={label} className="list-group-item">
          <b>{label}</b>
          <span className="pull-right">{value}</span>
        </li>
      ))}
    </ul>
  </>
);
